<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 角色列表aa
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_box">
      <!-- 顶部的盒子 -->
      <div class="top_box">
        <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="addRole">新增角色</el-button>
        <el-input v-model="searchKey" clearable size="mini" placeholder="输入关键字搜索"
          @change="searchKeyChange(tableData,searchKey)">
          <el-button slot="append" icon="el-icon-search" @click="searchKeyChange(tableData,searchKey)"></el-button>
        </el-input>
      </div>
      <!--表格-->
      <div class="table_box">
        <el-table :data="tableDataEnd" @sort-change="onSortChange">
          <!-- 扩展行 -->
          <el-table-column type="expand">
            <template slot-scope="props">
              <!-- 循环一级权限 -->
              <el-row :class="['vcenter','bdbottom',index1===0? 'bdtop':'']"
                v-for="(item1,index1) in props.row.permissions" :key="item1.id">
                <el-col :span="5">
                  <el-tag>{{item1.name}}</el-tag>
                  <i class="el-icon-caret-right"></i>
                </el-col>
                <el-col :span="19">
                  <!-- 循环二级权限 -->
                  <el-row :class="['vcenter',index2!==0? 'bdtop':'']" v-for="(item2,index2) in item1.children"
                    :key="item2.id">
                    <el-col :span="6">
                      <el-tag type="success">{{item2.name}}</el-tag>
                      <i class="el-icon-caret-right"></i>
                    </el-col>
                    <el-col :span="18">
                      <!-- 循环三级权限 -->
                      <el-tag type="warning" :class="[index3!==0? 'bdtop':'']" v-for="(item3,index3) in item2.children"
                        :key="item3.id">{{item3.name}}</el-tag>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>
          <el-table-column label="名称" align="center" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="160" prop="name"></el-table-column>
          <el-table-column label="描述" align="left" sortable="custom" :sort-orders="['ascending','descending']"
            min-width="320" prop="description"></el-table-column>
          <el-table-column label="操作" align="center" min-width="180">
            <template slot-scope="row">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="editRole(row)">编辑</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteRole(row)">删除</el-button>
              <el-button size="mini" type="warning" icon="el-icon-setting" @click="setRole(row)">配置权限</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页栏 -->
      <div class="pagination_box">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[4, 8, 12]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems">
        </el-pagination>
      </div>
    </div>
    <!-- 新增角色对话框 -->
    <div>
      <el-dialog title="新增角色" :visible.sync="addDialogFormVisible" width="320px"
        :before-close="((done)=>{closeDialog('addRoleForm',done)})">
        <el-form :model="addRoleForm" label-position="right" label-width="55px" ref="addRoleForm"
          :rules="addRoleFormRules">
          <el-form-item label="名称" prop="name">
            <el-input v-model="addRoleForm.name" autocomplete="off" clearable size="small"
              placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="addRoleForm.description" type="textarea" :rows="4" autocomplete="off" clearable
              size="small" placeholder="请输入描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="submitAddRoleForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 编辑角色对话框 -->
    <div>
      <el-dialog title="编辑角色" :visible.sync="editDialogFormVisible" width="320px">
        <el-form :model="editRoleForm" label-position="right" label-width="55px" ref="editRoleForm"
          :rules="editRoleFormRules">
          <el-form-item label="名称" prop="name">
            <el-input v-model="editRoleForm.name" autocomplete="off" clearable size="small"
              placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="editRoleForm.description" type="textarea" :rows="4" autocomplete="off" clearable
              size="small" placeholder="请输入描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="submitEditRoleForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 配置权限对话框 -->
    <div>
      <el-dialog class="set-role-dialog" title="配置权限" :visible.sync="setDialogFormVisible" width="320px"
        @close="clearDefaultKeys">
        <el-form :model="setRoleForm" label-position="right" ref="setRoleForm">
          <el-form-item prop="permissions">
            <el-tree :data="permissionsData" show-checkbox node-key="id" :props="treeDefaultProps" default-expand-all
              :default-checked-keys="defaultKeys" ref="tree"></el-tree>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="submitSetRoleForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'roles',
    components: {

    },
    data() {
      return {
        // 表格************************************************************************
        // 表格总数据
        tableData: [{
            id: 1,
            name: "管理员",
            description: "管理员",
            permissions: [{
              id: 1,
              name: "学生管理",
              path: "/",
              class: 0,
              children: [{
                  id: 2,
                  name: "学生列表",
                  path: "学生管理 /",
                  class: 1,
                  children: [{
                      id: 3,
                      name: "查看学生列表",
                      path: "学生管理 / 学生列表 /",
                      class: 2
                    },
                    {
                      id: 4,
                      name: "编辑学生列表",
                      path: "学生管理 / 学生列表 /",
                      class: 2
                    },
                  ]
                },
                {
                  id: 5,
                  name: "权限列表",
                  path: "学生管理 /",
                  class: 1,
                  children: [{
                    id: 6,
                    name: "查看权限列表",
                    path: "学生管理 / 权限列表 /",
                    class: 2
                  }, ]
                },
                {
                  id: 7,
                  name: "角色列表",
                  path: "学生管理 /",
                  class: 1,
                  children: [{
                      id: 8,
                      name: "查看角色列表",
                      path: "学生管理 / 角色列表 /",
                      class: 2
                    },
                    {
                      id: 9,
                      name: "编辑角色列表",
                      path: "学生管理 / 角色列表 /",
                      class: 2
                    },
                  ]
                },
              ]
            }, ]
          },
          {
            id: 2,
            name: "学生",
            description: "学生",
            permissions: [{
              id: 1,
              name: "角色管理",
              path: "/",
              class: 0,
              children: [{
                  id: 2,
                  name: "权限列表",
                  path: "学生管理 /",
                  class: 1,
                  children: [{
                    id: 3,
                    name: "查看权限列表",
                    path: "学生管理 / 权限列表 /",
                    class: 2
                  }, ]
                },
                {
                  id: 4,
                  name: "角色列表",
                  path: "学生管理 /",
                  class: 1,
                  children: [{
                      id: 5,
                      name: "查看角色列表",
                      path: "学生管理 / 角色列表 /",
                      class: 2
                    },
                    {
                      id: 6,
                      name: "编辑角色列表",
                      path: "学生管理 / 角色列表 /",
                      class: 2
                    },
                  ]
                },
              ]
            }, ]
          },
        ],
        // 表格可检索内容 用于检索
        tableDataForm: {
          name: "",
          description: "",
          permissions: [{
            name: "",
            children: [{
              name: "",
              children: [{
                name: ""
              }]
            }]
          }],
        },
        // 新增角色表单************************************************************************
        // 新增角色对话框标识符
        addDialogFormVisible: false,
        // 新增角色表单
        addRoleForm: {
          name: "",
          description: "",
        },
        // 新增角色验证
        addRoleFormRules: {
          name: [{
            required: true,
            message: "请输入姓名",
            trigger: ["blur"]
          }],
          description: [{
            required: true,
            message: "请输入描述",
            trigger: ["blur"]
          }],
        },
        // 编辑角色表单************************************************************************
        // 编辑角色对话框标识符
        editDialogFormVisible: false,
        // 新增角色表单
        editRoleForm: {
          name: "",
          description: "",
        },
        // 新增角色验证
        editRoleFormRules: {
          name: [{
            required: true,
            message: "请输入姓名",
            trigger: ["blur"]
          }],
          description: [{
            required: true,
            message: "请输入描述",
            trigger: ["blur"]
          }],
        },
        // 配置权限表单************************************************************************
        // 配置权限对话框标识符
        setDialogFormVisible: false,
        // 配置权限表单
        setRoleForm: {},
        // 树形配置
        treeDefaultProps: {
          children: 'children',
          label: 'name'
        },
        // 默认选中的节点
        defaultKeys: [],
        // 搜索************************************************************************
        // 搜索关键字
        searchKey: "",
        // 搜索结果
        searchResult: [],
        // 分页***********************************************************************
        // 采集设备表格前页数据
        tableDataEnd: [],
        // 当前页数
        currentPage: 1,
        // 表格展示的行数
        pageSize: 8,
        // 总行数
        totalItems: 0,
        // 当前行
        currentRow: 0,
        // 当前表格排序
        currentSort: null,
        // 其他***********************************************************************
        // 权限数据
        permissionsData: [{
          id: 1,
          name: "学生管理",
          path: "/",
          class: 0,
          children: [{
              id: 2,
              name: "学生列表",
              path: "学生管理 /",
              class: 1,
              children: [{
                  id: 3,
                  name: "查看学生列表",
                  path: "学生管理 / 学生列表 /",
                  class: 2
                },
                {
                  id: 4,
                  name: "编辑学生列表",
                  path: "学生管理 / 学生列表 /",
                  class: 2
                },
              ]
            },
            {
              id: 5,
              name: "权限列表",
              path: "学生管理 /",
              class: 1,
              children: [{
                id: 6,
                name: "查看权限列表",
                path: "学生管理 / 权限列表 /",
                class: 2
              }, ]
            },
            {
              id: 7,
              name: "角色列表",
              path: "学生管理 /",
              class: 1,
              children: [{
                  id: 8,
                  name: "查看角色列表",
                  path: "学生管理 / 角色列表 /",
                  class: 2
                },
                {
                  id: 9,
                  name: "编辑角色列表",
                  path: "学生管理 / 角色列表 /",
                  class: 2
                },
              ]
            },
          ]
        }, ],
      };
    },
    created() {
      // 请求表格数据
      this.getTableData(false)
    },
    mounted() {

    },
    methods: {
      // *********************************************************************************************************
      // 表格数据获取
      // *********************************************************************************************************
      // 请求表格数据 flag为是否还原表格状态
      getTableData(flag) {
        // TODO 获取表格数据
        this.totalItems = this.tableData.length
        this.handleCurrentChange(1)
      },
      // *********************************************************************************************************
      // 新增角色
      // *********************************************************************************************************
      // 添加角色
      addRole(row) {
        this.addDialogFormVisible = !this.addDialogFormVisible
      },
      // 提交添加角色表单
      submitAddRoleForm() {
        this.$refs['addRoleForm'].validate((valid) => {
          if (valid) {
            this.tableData.push(JSON.parse(JSON.stringify(this.addRoleForm)))
            this.totalItems = this.tableData.length
            this.handleCurrentChange(1)
            this.addDialogFormVisible = false
            this.$refs['addRoleForm'].resetFields();
          } else {
            return false;
          }
        });
      },
      // *********************************************************************************************************
      // 编辑角色
      // *********************************************************************************************************
      // 编辑角色
      editRole(row) {
        this.editDialogFormVisible = !this.editDialogFormVisible
        this.currentRow = row.$index
        this.editRoleForm = JSON.parse(JSON.stringify(row.row))
      },
      // 提交编辑角色表单
      async submitEditRoleForm() {
        try {
          // 执行更新角色数据的操作
          const response = await this.$http.post('/role/update', this.editRoleForm);
          // 更新成功，可以进行一些操作，如关闭编辑对话框等
          this.editDialogFormVisible = !this.editDialogFormVisible;
          console.log('编辑后的角色表单数据:', this.editRoleForm);
          console.log('更新后的表格数据:', this.tableData);

          // 更新表格数据
          const index = this.currentRow;
          if (index !== -1) {
            // this.tableData.splice(index, 1, this.editRoleForm);
            this.$set(this.tableData, index, this.editRoleForm);
          }
          // 自动刷新表格数据
          this.getTableData(false);
        } catch (error) {
          // 处理更新失败的情况，可以进行一些错误处理操作
          console.error('更新角色数据失败:', error);
        }
      },
      // *********************************************************************************************************
      // 删除角色
      // *********************************************************************************************************
      // 删除角色
      deleteRole(row) {
        const index = this.tableData.indexOf(row.row);
        if (index !== -1) {
          this.tableData.splice(index, 1);
          this.totalItems = this.tableData.length;
          this.handleCurrentChange(this.currentPage);
        }
      },
      // *********************************************************************************************************
      // 配置权限
      // *********************************************************************************************************
      // 配置权限
      setRole(row) {

        this.currentRow = row.$index
        this.setRoleForm = JSON.parse(JSON.stringify(row.row))
        row.row.permissions.forEach(item => this.getDefaultKeys(item))
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.defaultKeys)
        })
        this.setDialogFormVisible = !this.setDialogFormVisible
      },
      // 获取角色的权限id
      getDefaultKeys(data) {
        if (!data.children) {
          return this.defaultKeys.push(data.id)
        } else {
          data.children.forEach(item =>
            this.getDefaultKeys(item)
          )
        }
      },
      // 提交配置权限表单
      submitSetRoleForm() {
        var keys = [
          ...this.$refs.tree.getHalfCheckedKeys(),
          ...this.$refs.tree.getCheckedKeys()
        ]
        var keysStr = keys.join(',')
        console.log(this.setRoleForm.id, keys, keysStr);
        this.setDialogFormVisible = !this.setDialogFormVisible
      },
      clearDefaultKeys() {
        this.defaultKeys = []
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.defaultKeys)
        })
      },
      // *********************************************************************************************************
      // 表格排序功能
      // *********************************************************************************************************
      // 表头某列点击排序
      onSortChange({
        prop,
        order
      }) {
        this.currentSort = {
          prop,
          order
        }
        if (this.searchKey === "") {
          this.tableData.sort(this.compare(prop, order));
        } else {
          this.searchResult.sort(this.compare(prop, order));
        }
        this.handleCurrentChange(this.currentPage)
      },
      // 排序比较
      compare(propertyName, sort) {
        return function(obj1, obj2) {
          var value1 = obj1[propertyName]
          var value2 = obj2[propertyName]
          if (typeof value1 === 'string' && typeof value2 === 'string') {
            const res = value1.localeCompare(value2, 'zh')
            return sort === 'ascending' ? res : -res
          } else {
            if (value1 <= value2) {
              return sort === 'ascending' ? -1 : 1
            } else if (value1 > value2) {
              return sort === 'ascending' ? 1 : -1
            }
          }
        }
      },
      // *********************************************************************************************************
      // 表格搜索功能
      // *********************************************************************************************************
      // 关键字变化或输入框失焦后的操作
      searchKeyChange(tableData, key) {
        if (key !== "") {
          this.searchResult = tableData.filter((obj) => this.searchCheck(obj, this.tableDataForm))
          this.totalItems = this.searchResult.length
        } else {
          this.totalItems = this.tableData.length
        }
        this.handleCurrentChange(1)
      },
      // 判断对象中是否包含搜索关键字 返回布尔值
      searchCheck(obj, form) {
        var flag = false
        for (let i = 0; i < Object.getOwnPropertyNames(obj).length - 1; i++) {
          // 获取对象的第i个key值
          var originalKey = Object.getOwnPropertyNames(obj)[i]
          for (let j = 0; j < Object.getOwnPropertyNames(form).length - 1; j++) {
            // 获取表格样式的第j个key值
            var targetKey = Object.getOwnPropertyNames(form)[j]
            // 如果key值匹配 则进行搜索
            if (originalKey === targetKey) {
              var value = Object.values(obj)[i]
              // 判断是否是数组
              if (Array.isArray(value)) {
                // 如果是数组 则遍历数组中的元素 调用searchCheck返回布尔值
                for (let k = 0; k < value.length; k++) {
                  flag = flag || this.searchCheck(value[k], Object.values(form)[j][0])
                }
                break
              }
              // 判断是否是对象
              else if (Object.prototype.toString.call(value) === '[object Object]') {
                // 如果是对象 则遍历对象元素 调用searchCheck返回布尔值
                flag = flag || this.searchCheck(value[k], Object.values(form)[j])
                break
              }
              // 判断是否是数字
              else if (typeof(Object.values(obj)[i]) === "number") {
                value = Object.values(obj)[i].toString()
              }
              // 判断是否是字符串
              else if (typeof(Object.values(obj)[i]) === "string") {
                value = Object.values(obj)[i]
              } else {
                break;
              }
              // 判断是否和关键词匹配
              flag = flag || value.toLowerCase().includes(this.searchKey.toLowerCase())
            }
          }
        }
        return flag
      },
      // *********************************************************************************************************
      // 分页功能
      // *********************************************************************************************************
      //监控当前页码 页码变化后 重新选取当前页的数据
      currentChangePage(list) {
        // from：当前页的第一行数据在list中的序号  to：下一页的第一行数据在list中的序号
        let from = (this.currentPage - 1) * this.pageSize;
        let to = this.currentPage * this.pageSize;
        this.tableDataEnd = [];
        for (; from < to; from++) {
          if (list[from]) {
            this.tableDataEnd.push(list[from]);
          }
        }
      },
      //每页展示的行数变化后的操作
      handleSizeChange(val) {
        this.pageSize = val;
        this.handleCurrentChange(1);
      },
      //页码变化后的操作
      handleCurrentChange(val) {
        this.currentPage = val;
        // 判断是否在搜索
        if (this.searchKey === "") {
          this.currentChangePage(this.tableData);
        } else {
          this.currentChangePage(this.searchResult);
        }
      },
      // *********************************************************************************************************
      // 其他
      // *********************************************************************************************************
      // 关闭对话框
      closeDialog(ref, done) {
        this.$refs[ref].resetFields();
        done()
      },
    }
  };
</script>

<style lang="less" scoped>
  .main_box {
    border-radius: 8px 8px 8px 8px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
  }

  .top_box {
    text-align: right;
    background-color: #fff;
    padding: 10px 20px;
    border-bottom: 1px solid #E9EEF7;
    border-radius: 8px 8px 0px 0px;

    .el-input {
      width: 240px;
      margin-left: 10px;
    }

    .el-input .el-button {
      width: 40px;
      padding: 0;
    }
  }

  .table_box {
    background-color: #fff;
    padding: 10px 20px;

    /deep/ .el-table__header tr th.el-table__cell {
      color: #515a6e;
      background-color: #f8f8f9;
      padding: 8px 0;

      .cell {
        height: 34px;
        line-height: 34px;
      }
    }

    /deep/ .el-table__expanded-cell {
      padding: 20px 30px;
      background-color: #fcfcfc;
    }

    /deep/ tr:has(.el-table__expanded-cell) {
      background-color: #fcfcfc;
    }
  }

  .pagination_box {
    padding: 0px 20px 10px 20px;
    text-align: center;
    background-color: #fff;
    border-radius: 0px 0px 8px 8px;
  }

  /deep/ .el-dialog {
    border-radius: 8px 8px 8px 8px;
  }

  /deep/ .el-dialog__header {
    height: 50px;
    line-height: 50px;
    padding: 0 30px 0 30px;
    border-bottom: 1px solid #e0e0e0;

    .el-dialog__title {
      color: #666;
      font-size: 18px;
      font-weight: 700;
    }
  }

  /deep/ .el-dialog__body {
    padding: 15px 20px 0 20px;
  }

  /deep/ .el-dialog__footer {
    padding-top: 10px;
  }

  .el-dialog .el-button {
    width: 100%;
  }

  .el-form {
    width: 100%;
    margin: 0 auto;

    .el-form-item {
      margin-bottom: 10px;

      /deep/ .el-textarea {
        margin: 4px 0;
      }

      /deep/ textarea {
        font-family: Arial;
      }
    }

    /deep/ .el-form-item__error {
      padding-top: 0;
    }
  }

  /deep/ .el-form-item__label {
    color: #666;
  }

  .el-tag {
    margin: 7px;
  }

  .bdtop {
    border-top: 1px solid #eee;
  }

  .bdbottom {
    border-bottom: 1px solid #eee;
  }

  .vcenter {
    display: flex;
    align-items: center;
  }

  .set-role-dialog .el-form-item {
    height: 500px;
    overflow-y: auto;
  }
</style>
